import {Base} from "@/api/Base"

export class LeaveGetHistoryLeave extends Base {
    path = "leave/getHistoryLeave"
}